import { Component, OnInit,Input } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-banner-home',
  templateUrl: './banner-home.component.html',
  styleUrls: ['./banner-home.component.sass']
})
export class BannerHomeComponent implements OnInit {
  @Input() type;
  public rotationTime:number=30000;
  constructor(private router: Router) { }

  ngOnInit() {
  }
  goToIptv(){
    this.router.navigate(['iptv/1']);
  }
}
